<div class="login-page">
  <!-- Brand panel (hidden below 1024px) -->
  <aside class="brand-panel" aria-hidden="true">
    <app-festive-fireworks [contained]="true" [duration]="4500" [fountains]="[0.1, 0.9]"></app-festive-fireworks>
    <!-- Background: dot grid + shop illustration (inline so it follows the theme tokens) -->
    <svg class="brand-grid" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <pattern id="login-dots" width="24" height="24" patternUnits="userSpaceOnUse">
          <circle cx="2" cy="2" r="1" />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#login-dots)" />
    </svg>

    <svg class="brand-art" viewBox="0 0 560 400" xmlns="http://www.w3.org/2000/svg">
      <!-- ground -->
      <line class="a-line" x1="16" y1="360" x2="544" y2="360" />

      <!-- floating sales card -->
      <g class="a-float">
        <rect class="a-fill" x="404" y="32" width="136" height="96" rx="8" />
        <rect class="a-soft" x="420" y="48" width="48" height="8" rx="4" />
        <rect class="a-tint" x="420" y="96" width="14" height="20" rx="2" />
        <rect class="a-tint" x="442" y="84" width="14" height="32" rx="2" />
        <rect class="a-tint" x="464" y="90" width="14" height="26" rx="2" />
        <rect class="a-accent" x="486" y="68" width="14" height="48" rx="2" />
        <rect class="a-tint" x="508" y="78" width="14" height="38" rx="2" />
      </g>

      <!-- storefront -->
      <rect class="a-fill" x="200" y="172" width="240" height="188" />
      <rect class="a-tint" x="272" y="112" width="96" height="24" rx="4" />
      <rect class="a-accent" x="292" y="121" width="56" height="6" rx="3" />
      <!-- awning -->
      <rect class="a-fill" x="188" y="140" width="264" height="32" />
      <rect class="a-tint-strong" x="188" y="140" width="33" height="32" />
      <rect class="a-tint-strong" x="254" y="140" width="33" height="32" />
      <rect class="a-tint-strong" x="320" y="140" width="33" height="32" />
      <rect class="a-tint-strong" x="386" y="140" width="33" height="32" />
      <path class="a-fill"
        d="M188 172 a16.5 16.5 0 0 0 33 0 a16.5 16.5 0 0 0 33 0 a16.5 16.5 0 0 0 33 0 a16.5 16.5 0 0 0 33 0 a16.5 16.5 0 0 0 33 0 a16.5 16.5 0 0 0 33 0 a16.5 16.5 0 0 0 33 0 a16.5 16.5 0 0 0 33 0" />
      <!-- window with stocked shelves -->
      <rect class="a-soft-fill" x="220" y="204" width="128" height="124" rx="4" />
      <line class="a-line" x1="220" y1="246" x2="348" y2="246" />
      <line class="a-line" x1="220" y1="288" x2="348" y2="288" />
      <rect class="a-tint" x="232" y="222" width="16" height="24" rx="2" />
      <rect class="a-accent" x="254" y="214" width="16" height="32" rx="2" />
      <rect class="a-tint" x="276" y="226" width="20" height="20" rx="2" />
      <rect class="a-tint" x="304" y="218" width="12" height="28" rx="2" />
      <rect class="a-tint" x="322" y="226" width="16" height="20" rx="2" />
      <rect class="a-tint" x="232" y="268" width="24" height="20" rx="2" />
      <rect class="a-tint" x="262" y="260" width="12" height="28" rx="2" />
      <rect class="a-accent" x="282" y="264" width="20" height="24" rx="2" />
      <rect class="a-tint" x="310" y="256" width="16" height="32" rx="2" />
      <!-- door -->
      <rect class="a-fill" x="368" y="248" width="52" height="112" rx="2" />
      <rect class="a-soft-fill" x="378" y="260" width="32" height="40" rx="2" />
      <circle class="a-accent" cx="408" cy="312" r="3" />

      <!-- boxes -->
      <rect class="a-fill" x="64" y="288" width="96" height="72" rx="2" />
      <line class="a-line" x1="112" y1="288" x2="112" y2="312" />
      <rect class="a-fill" x="84" y="232" width="64" height="56" rx="2" />
      <line class="a-line" x1="116" y1="232" x2="116" y2="252" />
      <rect class="a-tint" x="96" y="264" width="24" height="8" rx="2" />

      <!-- plant -->
      <path class="a-tint-strong" d="M472 316 c-24 -8 -28 -36 -12 -52 c4 20 12 32 12 52 z" />
      <path class="a-tint-strong" d="M476 316 c20 -12 24 -40 8 -56 c-4 20 -10 36 -8 56 z" />
      <path class="a-fill" d="M456 316 h40 l-6 44 h-28 z" />
      <!-- Festival extras: toran on the shopfront, diyas, lantern, fireworks -->
      <g *ngIf="festiveService.festival()" class="a-festive">
        <defs>
          <radialGradient id="login-festive-glow">
            <stop offset="0" stop-color="#FFD166" stop-opacity="0.9" />
            <stop offset="1" stop-color="#FFD166" stop-opacity="0" />
          </radialGradient>
        </defs>
        <path class="f-string" d="M188 192 Q254 200 320 192 T452 192" />
        <g>
          <circle class="f-marigold" cx="200" cy="196" r="5" /><circle class="f-marigold-core" cx="200" cy="196" r="2.2" />
          <path class="f-leaf" d="M220 193 c-4 5 -4 10 0 15 c4 -5 4 -10 0 -15 z" />
          <circle class="f-marigold" cx="240" cy="196" r="5" /><circle class="f-marigold-core" cx="240" cy="196" r="2.2" />
          <path class="f-leaf" d="M260 193 c-4 5 -4 10 0 15 c4 -5 4 -10 0 -15 z" />
          <circle class="f-marigold" cx="280" cy="196" r="5" /><circle class="f-marigold-core" cx="280" cy="196" r="2.2" />
          <path class="f-leaf" d="M300 193 c-4 5 -4 10 0 15 c4 -5 4 -10 0 -15 z" />
          <circle class="f-marigold" cx="320" cy="196" r="5" /><circle class="f-marigold-core" cx="320" cy="196" r="2.2" />
          <path class="f-leaf" d="M340 193 c-4 5 -4 10 0 15 c4 -5 4 -10 0 -15 z" />
          <circle class="f-marigold" cx="360" cy="196" r="5" /><circle class="f-marigold-core" cx="360" cy="196" r="2.2" />
          <path class="f-leaf" d="M380 193 c-4 5 -4 10 0 15 c4 -5 4 -10 0 -15 z" />
          <circle class="f-marigold" cx="400" cy="196" r="5" /><circle class="f-marigold-core" cx="400" cy="196" r="2.2" />
          <path class="f-leaf" d="M420 193 c-4 5 -4 10 0 15 c4 -5 4 -10 0 -15 z" />
          <circle class="f-marigold" cx="440" cy="196" r="5" /><circle class="f-marigold-core" cx="440" cy="196" r="2.2" />
        </g>
        <line class="f-string" x1="110" y1="16" x2="110" y2="62" />
        <rect class="f-rim" x="102" y="62" width="16" height="6" rx="2" />
        <path class="f-marigold" d="M110 68 L130 92 L110 116 L90 92 Z" />
        <path class="f-marigold-core" d="M110 78 L120 92 L110 106 L100 92 Z" />
        <line class="f-string" x1="104" y1="112" x2="104" y2="132" />
        <line class="f-string" x1="110" y1="116" x2="110" y2="138" />
        <line class="f-string" x1="116" y1="112" x2="116" y2="132" />
        <g class="f-diya" transform="translate(178 360)">
          <circle class="f-glow" cx="0" cy="-21" r="11" />
          <path class="f-flame" d="M0 -31 C3.5 -26 4.5 -22 3 -18.5 C2.2 -16.8 1.2 -16 0 -16 C-1.2 -16 -2.2 -16.8 -3 -18.5 C-4.5 -22 -3.5 -26 0 -31 Z" />
          <path class="f-bowl" d="M-14 -10 C-7 -9 7 -9 14 -10 C13 -3 7 0 0 0 C-7 0 -13 -3 -14 -10 Z" />
          <ellipse class="f-rim" cx="0" cy="-10" rx="14" ry="2" />
        </g>
        <g class="f-diya" transform="translate(440 360)">
          <circle class="f-glow" cx="0" cy="-21" r="11" />
          <path class="f-flame" d="M0 -31 C3.5 -26 4.5 -22 3 -18.5 C2.2 -16.8 1.2 -16 0 -16 C-1.2 -16 -2.2 -16.8 -3 -18.5 C-4.5 -22 -3.5 -26 0 -31 Z" />
          <path class="f-bowl" d="M-14 -10 C-7 -9 7 -9 14 -10 C13 -3 7 0 0 0 C-7 0 -13 -3 -14 -10 Z" />
          <ellipse class="f-rim" cx="0" cy="-10" rx="14" ry="2" />
        </g>
        <g class="f-diya" transform="translate(526 360)">
          <circle class="f-glow" cx="0" cy="-21" r="11" />
          <path class="f-flame" d="M0 -31 C3.5 -26 4.5 -22 3 -18.5 C2.2 -16.8 1.2 -16 0 -16 C-1.2 -16 -2.2 -16.8 -3 -18.5 C-4.5 -22 -3.5 -26 0 -31 Z" />
          <path class="f-bowl" d="M-14 -10 C-7 -9 7 -9 14 -10 C13 -3 7 0 0 0 C-7 0 -13 -3 -14 -10 Z" />
          <ellipse class="f-rim" cx="0" cy="-10" rx="14" ry="2" />
        </g>
        <g class="f-burst f-burst--gold" transform="translate(300 44)"><line x1="0" y1="-7" x2="0" y2="-16" transform="rotate(0)" /><line x1="0" y1="-7" x2="0" y2="-16" transform="rotate(45)" /><line x1="0" y1="-7" x2="0" y2="-16" transform="rotate(90)" /><line x1="0" y1="-7" x2="0" y2="-16" transform="rotate(135)" /><line x1="0" y1="-7" x2="0" y2="-16" transform="rotate(180)" /><line x1="0" y1="-7" x2="0" y2="-16" transform="rotate(225)" /><line x1="0" y1="-7" x2="0" y2="-16" transform="rotate(270)" /><line x1="0" y1="-7" x2="0" y2="-16" transform="rotate(315)" /></g>
        <g class="f-burst f-burst--pink" transform="translate(232 92)"><line x1="0" y1="-4" x2="0" y2="-10" transform="rotate(0)" /><line x1="0" y1="-4" x2="0" y2="-10" transform="rotate(45)" /><line x1="0" y1="-4" x2="0" y2="-10" transform="rotate(90)" /><line x1="0" y1="-4" x2="0" y2="-10" transform="rotate(135)" /><line x1="0" y1="-4" x2="0" y2="-10" transform="rotate(180)" /><line x1="0" y1="-4" x2="0" y2="-10" transform="rotate(225)" /><line x1="0" y1="-4" x2="0" y2="-10" transform="rotate(270)" /><line x1="0" y1="-4" x2="0" y2="-10" transform="rotate(315)" /></g>
        <g class="f-burst f-burst--gold f-burst--late" transform="translate(360 96)"><line x1="0" y1="-4" x2="0" y2="-8" transform="rotate(0)" /><line x1="0" y1="-4" x2="0" y2="-8" transform="rotate(45)" /><line x1="0" y1="-4" x2="0" y2="-8" transform="rotate(90)" /><line x1="0" y1="-4" x2="0" y2="-8" transform="rotate(135)" /><line x1="0" y1="-4" x2="0" y2="-8" transform="rotate(180)" /><line x1="0" y1="-4" x2="0" y2="-8" transform="rotate(225)" /><line x1="0" y1="-4" x2="0" y2="-8" transform="rotate(270)" /><line x1="0" y1="-4" x2="0" y2="-8" transform="rotate(315)" /></g>
      </g>
    </svg>

    <span class="brand-eyebrow">Elixir POS &middot; Back Office</span>

    <div class="brand-copy">
      <h1 class="brand-title">Run every store from one place.</h1>
      <p class="brand-text">
        Products, stock, purchases, sales and accounts for all your stores and warehouses, kept in sync with every
        billing counter.
      </p>

      <ul class="feature-list">
        <li class="feature">
          <span class="feature-icon"><i class="pi pi-box"></i></span>
          <span>
            <strong>Stock you can trust</strong>
            <small>Live quantities across stores, warehouses and transfers</small>
          </span>
        </li>
        <li class="feature">
          <span class="feature-icon"><i class="pi pi-file-edit"></i></span>
          <span>
            <strong>Purchases and suppliers</strong>
            <small>Purchase entries, returns, dues and payments in one flow</small>
          </span>
        </li>
        <li class="feature">
          <span class="feature-icon"><i class="pi pi-chart-bar"></i></span>
          <span>
            <strong>Reports when you need them</strong>
            <small>Sales, returns, GST and receivables by store and date</small>
          </span>
        </li>
      </ul>
    </div>

    <span class="brand-verticals">Retail &middot; Pharmacy &middot; Mobile Shop</span>
  </aside>

  <!-- Form column -->
  <main class="form-panel">
    <svg class="form-grid" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <pattern id="login-dots-form" width="24" height="24" patternUnits="userSpaceOnUse">
          <circle cx="2" cy="2" r="1" />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#login-dots-form)" />
    </svg>

    <div class="form-wrap">
      <!-- Elixir_Retail-8.png is a 1080px square with the wordmark in the middle; crop to it -->
      <div class="logo-row">
        <span class="logo-crop"><img src="/Elixir_Retail-8.png" alt="Elixir Retail" /></span>
        <app-festive-doodle size="lg"></app-festive-doodle>
      </div>

      <!-- ── Sign in ── -->
      <ng-container *ngIf="!showResetForm">
        <header class="form-header">
          <h2>Sign in</h2>
          <p>Welcome back. Sign in to manage your business.</p>
        </header>

        <section class="saved-accounts" *ngIf="savedAccounts.length">
          <span class="section-label">Continue as</span>
          <button type="button" class="saved-account" *ngFor="let account of savedAccounts" (click)="continueAs(account)">
            <span class="saved-avatar"><i class="pi pi-building"></i></span>
            <span class="saved-text">
              <strong>{{ account.clientName }}</strong>
              <small>{{ account.userName }}</small>
            </span>
            <i class="pi pi-arrow-right saved-go"></i>
          </button>
          <div class="divider"><span>or sign in to another account</span></div>
        </section>

        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" novalidate>
          <div class="field">
            <label for="username">Username</label>
            <input id="username" type="text" pInputText formControlName="username" autocomplete="username"
              placeholder="Enter your username" [class.is-invalid]="fieldInvalid('username')" autofocus />
            <small class="field-error" *ngIf="fieldInvalid('username')">Username is required</small>
          </div>

          <div class="field">
            <label for="password">Password</label>
            <p-password formControlName="password" inputId="password" [feedback]="false" [toggleMask]="true"
              placeholder="Enter your password" autocomplete="current-password"
              [inputStyleClass]="fieldInvalid('password') ? 'is-invalid' : ''"></p-password>
            <small class="field-error" *ngIf="fieldInvalid('password')">Password is required</small>
          </div>

          <div class="form-row">
            <div class="remember">
              <p-checkbox [(ngModel)]="rememberMe" [binary]="true" inputId="rememberMe"
                [ngModelOptions]="{ standalone: true }"></p-checkbox>
              <label for="rememberMe">Remember me</label>
            </div>
            <button type="button" class="link-button" (click)="forgotPassword()" [disabled]="resetLoading">
              {{ resetLoading ? 'Sending code…' : 'Forgot password?' }}
            </button>
          </div>

          <div class="form-message" *ngIf="message" [class.is-error]="message.type === 'error'"
            [class.is-success]="message.type === 'success'" role="alert">
            <i class="pi" [ngClass]="message.type === 'error' ? 'pi-exclamation-circle' : 'pi-check-circle'"></i>
            <span>{{ message.text }}</span>
          </div>

          <button pButton type="submit" class="submit-button" [label]="loading ? 'Signing in…' : 'Sign in'"
            [loading]="loading" [disabled]="loading"></button>
        </form>
      </ng-container>

      <!-- ── Reset password ── -->
      <ng-container *ngIf="showResetForm">
        <header class="form-header">
          <span class="step-label">Step {{ otpVerified ? 2 : 1 }} of 2</span>
          <h2>{{ otpVerified ? 'Choose a new password' : 'Enter verification code' }}</h2>
          <p *ngIf="!otpVerified">Enter the 6-digit code sent to the contact registered for
            <strong>{{ loginForm.value.username }}</strong>.</p>
          <p *ngIf="otpVerified">Pick a password you don't use for other accounts.</p>
        </header>

        <form [formGroup]="resetForm" (ngSubmit)="onResetSubmit()" novalidate>
          <div class="field otp-field" *ngIf="!otpVerified">
            <label>Verification code</label>
            <p-inputotp formControlName="otp" [integerOnly]="true" [length]="6" />
          </div>

          <ng-container *ngIf="otpVerified">
            <div class="field">
              <label for="newPassword">New password</label>
              <p-password formControlName="newPassword" inputId="newPassword" [toggleMask]="true"
                placeholder="New password" autocomplete="new-password"></p-password>
            </div>
            <div class="field">
              <label for="confirmPassword">Confirm new password</label>
              <p-password formControlName="confirmPassword" inputId="confirmPassword" [feedback]="false"
                [toggleMask]="true" placeholder="Re-enter new password" autocomplete="new-password"></p-password>
            </div>
          </ng-container>

          <div class="form-message" *ngIf="message" [class.is-error]="message.type === 'error'"
            [class.is-success]="message.type === 'success'" role="alert">
            <i class="pi" [ngClass]="message.type === 'error' ? 'pi-exclamation-circle' : 'pi-check-circle'"></i>
            <span>{{ message.text }}</span>
          </div>

          <button pButton type="submit" class="submit-button" [loading]="resetLoading"
            [disabled]="resetLoading || resetForm.invalid"
            [label]="otpVerified ? 'Update password' : 'Verify code'"></button>
        </form>

        <button type="button" class="link-button back-link" (click)="backToSignIn()">
          <i class="pi pi-arrow-left"></i> Back to sign in
        </button>
      </ng-container>
    </div>

    <div class="form-assist">
      <span><i class="pi pi-lock"></i> Secure sign-in</span>
      <span class="assist-sep" aria-hidden="true"></span>
      <span>Trouble signing in? Contact your administrator.</span>
    </div>

    <div class="form-footer">&copy; {{ year }} Elixir POS. All rights reserved.</div>
  </main>
</div>
